import * as yup from 'yup';
import dayjs from 'dayjs';

const DATE_FORMAT = 'YYYY-MM';
const today = dayjs().startOf('month');
const hundredYearsAgo = today.subtract(100, 'year');
const strictDateRegex = /^\d{4}-(0[1-9]|1[0-2])$/;
const yyyyMMRegex = /^\d{4}-(0?[1-9]|1[0-2])$/;

export const ValidationSchema = yup.object({
  loanAmount: yup
    .number()
    .typeError('Please enter a valid amount you require')
    .positive('Please enter a valid amount you require')
    .required('How much do you need is a required field')
    .transform((value, originalValue) => {
      const trimmed = String(originalValue).trim();
      return trimmed === '' ? undefined : Number(trimmed);
    }),

  businessType: yup.string()
    .required('How is your business registered is a required field', (item) => !!item?.value),

  timeInBusiness: yup
    .string()
    .required('How long have you been in business is a required field')
    .test('not-too-old', 'Invalid Year: Cannot be greater than 100yrs old', value => {
      const date = dayjs(value, DATE_FORMAT, true);
      return date.isValid() && date.isAfter(hundredYearsAgo);
    })
    .test('is-past-date', 'Invalid Year: Date should be in the past', value => {
      const date = dayjs(value, DATE_FORMAT, true);
      return date.isValid() && (date.isBefore(today) || date.isSame(today));
    })
    .test('valid-format', 'Invalid Year: Please capture correct date', value => {
      const [year, month] = value.split('-').map(Number);
      if (!yyyyMMRegex.test(`${year}-${month}`)) {
        return false;
      }
      return strictDateRegex.test(value) && dayjs(value, DATE_FORMAT, true).isValid();
    }),

  financeReason: yup.string()
    .required('What do you need it for is a required field', (item) => !!item?.value),

  financeTenure: yup.string()
    .required('How long do you need it for is a required field', (item) => !!item?.value),

  revenue: yup.string()
    .required('What is your annual business income is a required field', (item) => !!item?.value)
});